.search-no-result,
.search-error {
  position: relative;
  overflow: hidden;

  svg.background {
    position: absolute;
    top: 0;
    left: 50%;
    width: 524px;
    transform: translate(-50%);
    // Vertical opacity gradient
    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    mask-size: 100% 75%;
    mask-repeat: no-repeat;
    mask-position: top, bottom;
    -webkit-mask-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 0)
    );
    -webkit-mask-size: 100% 75%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: top, bottom;
  }

  .search-icon,
  .error-icon {
    margin-top: 45px;
    margin-bottom: 16px;
  }

  h4 {
    line-height: 24px;
    margin-bottom: 4px;
    font-weight: var(--font-weight-medium);
  }
}

// ErrorView (.search-error) spaces its actions with mt-1.5 instead. This
// stylesheet is unlayered, so a rule here would beat that utility.
.search-no-result .actions {
  margin-top: 24px;
}
